import SwiperCore, { Autoplay } from 'swiper/core';
import { observeModal } from '../slider/slider.js';

export function initLandingPage() {
  initSeoText();
  initFootnotePopup();
  initJackpotSum();
  initGames();
  initTestimonialsLoop();
  initTerms();
}

function initSeoText() {
  if (document.querySelector('.js-country-landing-showMore')) {
    let opened = false;
    String.prototype.trunc =
      String.prototype.trunc ||
      function (n) {
        return this.length > n ? this.substr(0, n - 1) + '&hellip;' : this;
      };
    const dropdownTitle = document.querySelector('.js-seo-text-wrapper .dropdown-title');
    if (!dropdownTitle) {
      return;
    }
    let textWrapperList = document.querySelectorAll('.js-seo-text-wrapper *'),
      firstSeoItem = dropdownTitle.innerHTML,
      firstSetItemTrunc = firstSeoItem.trunc('450');
    dropdownTitle.innerHTML = firstSetItemTrunc;
    for (let i = 0, len = textWrapperList.length; i < len; i++) {
      textWrapperList[i].classList.add('hide');
    }
    document.querySelector('.js-seo-text-wrapper *:first-child').classList.remove('hide');
    document.querySelector('.js-country-landing-showMore').addEventListener('click', (e) => {
      opened = !opened;
      let switchBtns = e.currentTarget.querySelectorAll('.btn-text');
      for (let i = 0, len = switchBtns.length; i < len; i++) {
        switchBtns[i].classList.toggle('hide');
      }
      if (opened) {
        dropdownTitle.innerHTML = firstSeoItem;
        for (let i = 0, len = textWrapperList.length; i < len; i++) {
          textWrapperList[i].classList.remove('hide');
        }
      } else {
        for (let i = 0, len = textWrapperList.length; i < len; i++) {
          textWrapperList[i].classList.add('hide');
        }
        dropdownTitle.innerHTML = firstSetItemTrunc;
        document.querySelector('.js-seo-text-wrapper *:first-child').classList.remove('hide');
      }
    });
  }
}

async function initFootnotePopup() {
  const moduleFootnote = await import('../footnote/footnote.js');
  moduleFootnote.initFootnotePopup(document.querySelector('.landingPage'));
}

async function initGames() {
  let landingGamesList = document.querySelectorAll('.landing-page-games');
  for (var i = 0, len = landingGamesList.length; i < len; i++) {
    await getGames(landingGamesList[i].getAttribute('data-games'));
  }
}

async function getGames(category) {
  const moduleGames = await import('../games/get-all-games');
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  let gamesCollections = await moduleGames.getGamesCollections(),
    gameCollection = gamesCollections.find((t) => t.code === category || t.master_code === category),
    order = gameCollection ? gameCollection.items : '',
    allGames = await moduleGames.getAllGames();
  if (order != '') {
    let gamesList = removeGamesIfNotInArray(allGames, order);
    gamesList = moduleBasicFunc.arrayOrder(gamesList, order, 'id');
    createGames(gamesList, category);
  }
}

async function createGames(gamesList, gamesWraperAttr) {
  var gamesWrapper = document.querySelector('.landing-page-games[data-games="' + gamesWraperAttr + '"] .games-body');
  gamesWrapper.innerHTML = '';
  for (var i = 0, len = gamesList.length; i < len; i++) {
    var item = gamesList[i];
    if (item.id) {
      var gameElement = createLandingPageGameElement(item);
      gamesWrapper.appendChild(gameElement);
    }
  }
  SwiperCore.use([Autoplay]);
  let gamesPerView = gamesWrapper.getAttribute('data-per-view');
  gamesPerView = !gamesPerView || isNaN(gamesPerView) ? 6 : parseInt(gamesPerView);
  const gamesSlider = new SwiperCore(gamesWrapper.parentNode, {
    loop: true,
    slidesPerView: gamesPerView,
    spaceBetween: 5,
    speed: 300,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    breakpoints: {
      250: {
        slidesPerView: 2 > gamesPerView ? gamesPerView : 2,
        centeredSlides: true
      },
      600: {
        slidesPerView: 5 > gamesPerView ? gamesPerView : 5,
        centeredSlides: true
      },
      800: {
        slidesPerView: 5 > gamesPerView ? gamesPerView : 5
      },
      1500: {
        slidesPerView: gamesPerView
      }
    }
  });
  observeModal(gamesSlider);
}

/**
 * Create Landing Page game element
 * @param {Object} item game obj from json
 * @returns {Element} game element
 */
function createLandingPageGameElement(item) {
  let thumbsnailSrc = _CMS_MOBILE ? '/images/uploads/games-thumbs/x175' : '/images/uploads/games-thumbs/x300';

  var domString =
    '<div class="game swiper-slide"><div class="game-thumb"><img src="' +
    thumbsnailSrc +
    '/' +
    item.id +
    '.jpg" alt="' +
    item.name +
    '"></div><div class="game-title text-center">' +
    item.name +
    '</div><div class="game-labels ' +
    item.attribute +
    '"><div class="badge badge-red-gray bold new">new</div><div class="badge badge-red-gray bold hot">hot</div><div class="badge badge-yellow-gray bold jackpot js-jackpot"></div><div class="badge tournament"></div><div class="badge badge-green-white bold live">live</div></div></div>';
  const html = new DOMParser().parseFromString(domString, 'text/html');
  return html.body.firstChild;
}

/**
 * Return list of games based on collection json
 * @param {Object} allGames object with all games
 * @param {Array} carouselList list with games ids
 * @returns {Array} list of games
 */
function removeGamesIfNotInArray(allGames, carouselList) {
  var gamesList = [];
  for (var i = 0, len = allGames.length; i < len; i++) {
    if (carouselList.includes(allGames[i].id)) {
      gamesList.push(allGames[i]);
    }
  }
  return gamesList;
}

async function initJackpotSum() {
  let jackpotObj = await getJackpotObj(),
    jackpotCurrency = jackpotObj.currency,
    jackpotsSum = jackpotObj.jackpots_sum;
  if (document.querySelector('.jackpots-sum')) {
    initCounter('.jackpots-sum', jackpotsSum);
    document.querySelector('.currency').innerHTML = jackpotCurrency;
  }
}

/**
 * Returns jackpot obj
 * @returns {Number}
 */
async function getJackpotObj() {
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  const jsonKey = `api/jackpots-list/?country=${_CMS_USERIP}&currency=`,
    jsonUrl = moduleBasicFunc.getWalletURL(jsonKey),
    data = await moduleBasicFunc.getJSON(jsonUrl),
    jackpotObj = { currency: data.currency, jackpots_sum: data.jackpots_sum };
  return jackpotObj;
}

function initCounter(selector, jackpotsSum) {
  var hasEntered = false,
    section = document.querySelector(selector);
  window.addEventListener('scroll', () => {
    var shouldAnimate = window.scrollY + window.innerHeight >= section.offsetTop;
    if (shouldAnimate && !hasEntered) {
      hasEntered = true;
      counter(selector, jackpotsSum);
    }
  });
}

function counter(selector, end) {
  let obj = document.querySelector(selector),
    start = 0,
    current = start,
    increment = 98765,
    step = 1,
    timer = setInterval(() => {
      current += increment;
      obj.textContent = current.toLocaleString();
      if (current >= end) {
        obj.textContent = end.toLocaleString();
        clearInterval(timer);
        initIncrement(obj);
      }
    }, step);
}

function initIncrement(el) {
  let current = parseInt(el.textContent.replace(/\s/g, ''));
  setInterval(() => {
    current += 1;
    el.textContent = current.toLocaleString();
  }, 1000);
}

async function initTestimonialsLoop() {
  if (document.querySelector('.reviews')) {
    SwiperCore.use([Autoplay]);
    const commentsSlider = new SwiperCore('.module-reviews.swiper-container', {
      loop: true,
      slidesPerView: 5,
      spaceBetween: 10,
      speed: 300,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      breakpoints: {
        250: {
          slidesPerView: 1,
          centeredSlides: true
        },
        1000: {
          slidesPerView: 3,
          centeredSlides: true
        },
        1200: {
          slidesPerView: 4
        },
        1500: {
          slidesPerView: 5
        }
      }
    });
    observeModal(commentsSlider);
  }
}

function initTerms() {
  if (document.querySelector('.js-cms-terms-here')) {
    document
      .querySelector('.landingPage main')
      .insertBefore(document.querySelector('.js-cms-terms'), document.querySelector('.js-cms-terms-here'));
    document.querySelector('.js-cms-terms-here').remove();
  }
}
